import {gql} from '@apollo/client';
import {
    PageRequestTypeInput,
    ReviewTaskFiltersTypeInput,
    ReviewTaskListItem,
    ReviewTaskListPage,
} from '../types/ReviewTaskType';

export const REVIEW_TASK_LIST_FIELDS = `
    reviewTaskId
    bizType
    bizId
    status
    submittedBy
    submitterName
    submitterPhone
    submittedAt
    slaDueAt
    reviewerId
    reviewerName
    reviewedAt
    trackingNumber
    orderId
    dspId
    dspName
    driverId
    driverName
    bizSubType
`;

export const GET_REVIEW_TASK_LIST = gql`
    query GetReviewTaskList(
        $filters: ReviewTaskFiltersTypeInput!,
        $pageRequest: PageRequestTypeInput
    ) {
        getReviewTaskPageList(filters: $filters, pageRequest: $pageRequest) {
            content {
                ${REVIEW_TASK_LIST_FIELDS}
            }
            totalElements
            page
            size
        }
    }
`;

export interface GetReviewTaskListResponse {
    getReviewTaskPageList: ReviewTaskListPage;
}

export interface GetReviewTaskListVariables {
    filters: ReviewTaskFiltersTypeInput;
    pageRequest?: PageRequestTypeInput;
}

export type {ReviewTaskListItem};
